    // const portUrl = 'http://localhost:60004/api/services/app/';
  const portUrl = 'https://webapi.wincheers.net/api/services/app/';//生产地址
//const portUrl = 'https://api1.wincheers.com/api/services/app/';//测试地址
 const httpUrl = {
	//tokenUrl:'https://webapi-sj.wincheers.net.cn/api/services/oauth/token',//登录
	//Url:'https://api1.wincheers.com',//地址
	Url:'https://webapi.wincheers.net',//地址
	GetSellerUrl: portUrl + 'seller/GetSeller', //验证用户登录信息
	indexUrl:portUrl+'page/GetUePageList',//首页广告
	
	ProductUrl:portUrl+'product/GetUeProduct?id=',//商品详情带参数,
	GetUeProductCoverPlate:portUrl+'/product/GetUeProductCoverPlate', //商品详情额外盖板
	ProductListUrl:portUrl+'product/GetUeProductList',//商品列表
	
	GetUeColorListUrl:portUrl+'ueColor/GetUeColorList',//定制
	
	//我的
	EditAddressUrl: portUrl + 'buyerAddressBook/EditAddress', //添加收货地址
    GetBuyerAddressBookListUrl: portUrl + 'buyerAddressBook/GetBuyerAddressBookList', //获取用户地址列表
    DelAddressUrl: portUrl + 'buyerAddressBook/DelAddress', //删除地址
    
    
   
    GetUePriceUrl: portUrl + 'uePrice/GetUePrice', //添加项价格
    TradeInitialUrl: portUrl + 'trade/UeTradeInitialization', //订单(正常)信息
    UeCreateOrderUrl: portUrl + 'trade/UeCreateOrder', //创建订单
    
    
    UpdatePwdUrl:portUrl+'crmAccount/UpdatePwd',//修改密码
	
	MyAddresUrl:portUrl+'buyerAddressBook/GetBuyerAddressBookList',//我的地址
	
	CreateOrUpdateStoreAddresUrl:portUrl+'buyerAddressBook/EditAddress',//新增修改地址
	
	GetBuyerAddressUrl:portUrl+'buyerAddressBook/GetBuyerAddressBook?id=',//根据id查询地址
	GetDefaulUrl:portUrl+'buyerAddressBook/GetDefault?id=',//修改成默认地址
	DelAddressUrl:portUrl+'buyerAddressBook/DelAddress?id=',//删除地址
	 GetUeTradeListUrl:portUrl+'Trade/GetUeTradeList',//ue订单列表
	 
	  UeCancelOrderUrl:portUrl+'Trade/UeCancelOrder',//取消订单
    
   
	 WapAlipayUrl:portUrl+'Trade/WapAlipay',//移动端支付宝支付
	 
	 PcAlipaySendUrl:portUrl+'Trade/PcAlipaySend',//PC端支付宝支付
       GetCodeUrl:portUrl+'Trade/GetCode',//获取code
   	 getWxInfoUrl:portUrl+'Trade/getWxInfo',//获取openid
   	 MeterRechargeUrl:portUrl+'Trade/meterRecharge',//付款
   	 GetBuyerTradeNoUrl:portUrl+'trade/GetBuyerTradeNo?TradeNo=',//订单详情
   	       
	 UeCancelOrderUrl:portUrl+'Trade/UeCancelOrder?id=',//取消订单
	 
	GetBuyerTradeNoUrl:portUrl+'trade/GetBuyerTradeNo?TradeNo=',//订单详情
	
	UeSendCodeUrl:portUrl+'crmAccount/UeSendCode?Phone=',//获取验证码
	PwdSendCodeUrl:portUrl+'crmAccount/PwdSendCode?Phone=',//获取验证码（已注册过）
	
	UeRegisterUrl:portUrl+'crmAccount/UeRegister?Phone=',//注册  Phone=18321861057&Pwd=1&Code=1
	UpdatePasswordUrl:portUrl+'crmAccount/UpdatePassword?Phone=',//忘记（）修改密码?Phone=18321861057&Pwd=1&Code=1
	UeTradeUrl:portUrl+'trade/UeTrade?TradeNo=',//订单详情	
	
	TradeStatusUrl:portUrl+'trade/TradeStatus?TradeNo=',//
	GetIsLogin:portUrl+'crmAccount/GetIsLogin',//是否登录
	GetUeTradeitemList:portUrl+'ueTradeItem/GetUeTradeitemList',//查询定制信息
	UpdateTradeItemUrl:portUrl+'trade/UpdateTradeItem',//修改定制信息
}
export default {
	httpUrl
}


// WEBPACK FOOTER //
// ./src/js/port.js